import { POLICIES } from '@vlabs/api-bindings/src/luna-client/handlers/constants';
import { read as mapLegacyHandlerRecord } from '@vlabs/api-bindings/src/luna-client/handlers/mappers/schemes/read.js';

const getTtlOption = (ttl) => {
  if (ttl === undefined) return undefined;

  return POLICIES.TTL.raw.find(({ value }) => value === ttl);
};

function mapHandlerRecordToFormValues(handler) {
  const legacyValues = mapLegacyHandlerRecord(handler);
  const storagePolicy = handler.policies.storage_policy;

  return {
    callbacksPolicy: legacyValues.callbacksPolicy,
    description: legacyValues.description,
    estimate: legacyValues.estimate,
    estimate_deepfake: {
      estimate: legacyValues.estimate_deepfake?.estimate,
      real_threshold: legacyValues.estimate_deepfake?.real_threshold,
    },
    estimate_face_occlusion: legacyValues.estimate_face_occlusion,
    estimate_liveness: legacyValues.estimate_liveness,
    estimate_people_count: legacyValues.estimate_people_count,
    eventPolicy: legacyValues.eventPolicy,
    extract: legacyValues.extract,
    faceQuality: legacyValues.faceQuality,
    filters: legacyValues.filters,
    owner_department_id: handler.owner_department_id,
    matchPolicy: handler.policies.match_policy ?? [],
    faceSamplePolicy: {
      ...legacyValues.faceSamplePolicy,
      ttl: getTtlOption(storagePolicy?.face_sample_policy?.ttl),
    },
    bodySamplePolicy: {
      ...legacyValues.bodySamplePolicy,
      ttl: getTtlOption(storagePolicy?.body_sample_policy?.ttl),
    },
    imageOriginPolicy: {
      ...legacyValues.imageOriginPolicy,
      ttl: getTtlOption(storagePolicy?.image_origin_policy?.ttl),
    },
    tagPolicy: legacyValues.tagPolicy,
  };
}

export { mapHandlerRecordToFormValues };
